import { Tabs, Tab } from "@mui/material";
import { SearchType } from "@shared/publicportal/contracts/Search";
import "./SearchTypeSwitchingTabs.css";
import { memo } from "react";

interface SearchTypeSwitchingTabsProps {
    searchType: SearchType;
    onSearchTypeChanged: (searchType: SearchType) => void;
}

const SearchTypeSwitchingTabs: React.FC<SearchTypeSwitchingTabsProps> = memo(({ searchType, onSearchTypeChanged }) => {
    return (
        <Tabs
            className="search-type-switching-tab-container"
            aria-label="Select a search type"
            variant="scrollable"
            scrollButtons="auto"
            value={searchType}
            onChange={(e, selectedSearchType) => {
                onSearchTypeChanged(selectedSearchType);
            }}
        >
            <Tab className="search-type-switching-tab" disableRipple key="simple-search" label="Simple" value="Simple" />
            <Tab className="search-type-switching-tab" disableRipple key="advanced-search" label="Advanced" value="Advanced" />
            <Tab className="search-type-switching-tab" disableRipple key="map" label="Map" value="Map" />
        </Tabs>
    );
});

export default SearchTypeSwitchingTabs;
